module.exports = "/_next/static/main.2cfa5cacc90110ad7f8f03bbcb82a7b0.css";